export default __webpack_public_path__ + "static/media/ok-icon.c7463bfb.svg";